export enum PaperFormat {
  A4 = "a4",
  US_LETTER = "us_letter",
}
